import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../css';

function Education(props) {
  const { height, width, iconColor, backgroundColor } = props;

  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">
      <rect
        fill={backgroundColor}
        opacity={0.4}
        x="28.55"
        y="53.93"
        width="57.63"
        height="9.03"
        transform="translate(-24.52 57.68) rotate(-45)"
      />
      <path
        fill="none"
        stroke={iconColor}
        strokeMiterlimit={10}
        strokeWidth="2.33px"
        d="M40.4,82.11,86.29,36.23A7.67,7.67,0,0,0,75.45,25.39L29.66,71.17,21.09,90.85H95.33"
      />
      <line
        fill="none"
        stroke={iconColor}
        strokeMiterlimit={10}
        strokeWidth="2.33px"
        x1="73.76"
        y1="27.08"
        x2="84.6"
        y2="37.92"
      />
      <polyline
        fill="none"
        stroke={iconColor}
        strokeMiterlimit={10}
        strokeWidth="2.33px"
        points="29.66 71.17 40.5 82.01 21.09 90.85"
      />
    </svg>
  );
}

Education.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  backgroundColor: PropTypes.string,
  iconColor: PropTypes.string
};

Education.defaultProps = {
  height: undefined,
  width: 120,
  iconColor: colors.colorGrey02,
  backgroundColor: colors.iconGreen
};

export default Education;
